import { render, staticRenderFns } from "./UserEditTabAccount.vue?vue&type=template&id=235900e4"
import script from "./UserEditTabAccount.vue?vue&type=script&lang=js"
export * from "./UserEditTabAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports